import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import NumberFormat from 'react-number-format';
import moment from 'moment/moment';
import { withStyles } from 'material-ui/styles/index';
import GridItem from '../../../common/components/Drawer/GridItem';
import DrawerDivider from '../../../common/components/Drawer/DrawerDivider';

const styles = () => ({
    root: {
        marginLeft: '24px',
    },
});

function RequestedLoan(props) {
    const hasSoftCheck = props.steps[4].completed && props.decision === 'allow' && props.maxLendAmount.amount;
    return (
        <div>
            <DrawerDivider />
            <div className={props.classes.root}>
                <Grid
                    container
                    spacing={0}
                >
                    <GridItem
                        caption="Estimated property value"
                    >
                        <NumberFormat
                            value={props.estaminatedPropertyValue.amount}
                            displayType="text"
                            thousandSeparator
                            prefix="&pound;"
                        />
                    </GridItem>
                    <GridItem
                        caption="Estimated monthly rent"
                    >
                        <NumberFormat
                            value={props.estaminatedPropertyMonthlyRent.amount}
                            displayType="text"
                            thousandSeparator
                            prefix="&pound;"
                        />
                    </GridItem>
                    <GridItem
                        caption="Mortage term"
                    >
                        {moment.duration(props.requestedTimeSpan, 'months').humanize()}
                    </GridItem>
                    <GridItem
                        caption="Requested loan amount"
                    >
                        <NumberFormat
                            value={props.requestedLoanAmount.amount}
                            displayType="text"
                            thousandSeparator
                            prefix="&pound;"
                        />
                    </GridItem>
                    {hasSoftCheck &&
                    <GridItem
                        caption="Max. Loan Amount"
                    >
                        <NumberFormat
                            value={props.maxLendAmount.amount}
                            displayType="text"
                            thousandSeparator
                            prefix="&pound;"
                        />
                    </GridItem>
                    }
                </Grid>
            </div>
        </div>
    );
}

RequestedLoan.propTypes = {
    requestedLoanAmount: PropTypes.object.isRequired,
    estaminatedPropertyValue: PropTypes.object.isRequired,
    estaminatedPropertyMonthlyRent: PropTypes.object.isRequired,
    requestedTimeSpan: PropTypes.number.isRequired,
    maxLendAmount: PropTypes.object.isRequired,
    decision: PropTypes.string.isRequired,
    steps: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RequestedLoan);



// WEBPACK FOOTER //
// ./src/app/FormStepper/Drawer/components/RequestedLoan.js